import { TransferOrderStatus } from './transfer-order-status.js';
export const SHIPPED_TRANSFER_ORDER_STATUS_IDS = [
    TransferOrderStatus.SHIPPED,
    TransferOrderStatus.PARTIALLY_RECEIVED,
    TransferOrderStatus.RECEIVED,
];
//# sourceMappingURL=transfer-order-shipped-status-ids.js.map